import { isFunction } from '@pogokid/util/lodash'
import {
  SchedulerRangeDataContext,
  SchedulerContext,
  SchedulerDispatchContext,
  SchedulerPropsContext,
} from './schedulerContext'
import {
  SCHEDULE_PROVIDER_DEFAULT_PROPS,
  ScheduleProviderPropsWithDefaults,
  SchedulerProviderProps,
} from './SchedulerProviderProps'
import { useScheduler } from './useScheduler'
import { useCalculateSchedulerRangeData } from './useCalculateSchedulerRangeData.ts'

export function SchedulerProvider({
  children,
  ...restProps
}: SchedulerProviderProps) {
  const providerProps = {
    ...SCHEDULE_PROVIDER_DEFAULT_PROPS,
    ...restProps,
  } as ScheduleProviderPropsWithDefaults

  const [state, stateActions] = useScheduler(providerProps)

  const rangeMemo = useCalculateSchedulerRangeData({
    view: providerProps.view,
    selectedDate: restProps.selectedDate,
    week: providerProps.week,
    day: providerProps.day,
  })

  return (
    <SchedulerPropsContext.Provider value={providerProps}>
      <SchedulerContext.Provider value={state}>
        <SchedulerDispatchContext.Provider value={stateActions}>
          <SchedulerRangeDataContext.Provider value={rangeMemo}>
            {isFunction(children) ? children(state) : children}
          </SchedulerRangeDataContext.Provider>
        </SchedulerDispatchContext.Provider>
      </SchedulerContext.Provider>
    </SchedulerPropsContext.Provider>
  )
}
